import { render, staticRenderFns } from "./ConfirmReceived.vue?vue&type=template&id=5e5f1b94&scoped=true&"
import script from "./ConfirmReceived.vue?vue&type=script&lang=js&"
export * from "./ConfirmReceived.vue?vue&type=script&lang=js&"
import style0 from "./ConfirmReceived.vue?vue&type=style&index=0&id=5e5f1b94&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e5f1b94",
  null
  
)

export default component.exports